import { AuthorizationWrapper } from '@frontend/authorization';
import { CommonMessage } from '@frontend/lang';

import { useApplicationCreateButton } from './create-button.controller';
import { ApplicationCreateButtonProps } from './create-button.types';

export const ApplicationCreateButton = (props: ApplicationCreateButtonProps) => {
    const viewProps = useApplicationCreateButton(props);
    const hideButton = props.hide || (props.requiresWizard === true && !viewProps.wizardContext);

    return (
        <AuthorizationWrapper
            requiredPermissions={viewProps.createPermissions}
            showLoading={false}>
            {hideButton ? null : (
                <div
                    className='bg-brand-primary text-background-surface hover:bg-brand-secondary inline-flex items-center justify-center gap-2 rounded-lg px-4 py-2.5 text-base font-medium hover:cursor-pointer'
                    onClick={viewProps.onCreate}>
                    {props.label ?? CommonMessage.FORMS.CREATE_OBJECT(props.entity)}
                </div>
            )}
        </AuthorizationWrapper>
    );
};
